<template>
  <default-layout>
    <template>
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-form
              v-model="valid"
              @submit.prevent="createUser"
              ref="userCreateForm"
            >
              <v-card>
                <v-card-title>New User</v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="formUser.firstName"
                    :rules="nameRules"
                    :counter="10"
                    label="First name"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="formUser.lastName"
                    :rules="nameRules"
                    :counter="10"
                    label="Last name"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="formUser.email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="formUser.password"
                    :rules="passwordRules"
                    label="Password"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="formUser.confirmPassword"
                    :rules="passwordRules"
                    label="Confirm Password"
                    required
                  ></v-text-field>

                  <v-select
                    v-model="formUser.role"
                    :items="roleOptions"
                    item-text="name"
                    item-value="id"
                    label="Role"
                  ></v-select>

                  <v-checkbox
                    v-model="formUser.status"
                    label="Status"
                  ></v-checkbox>

                  <v-select
                    v-model="formUser.facilities"
                    :items="facilityOptions"
                    item-text="facilityId"
                    item-value="id"
                    label="Listing Access"
                    multiple
                    chips
                    clearable
                    deletable-chips
                    hint="What listings can this user access?"
                    persistent-hint
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="selectAllToggle">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              formUser.facilities.length > 0 ? 'error' : ''
                            "
                            >{{ icon }}</v-icon
                          >
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            formUser.facilities.length === 0
                              ? "Select All"
                              : "Select None"
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>

                    <template v-slot:item="{ item }">
                      {{ item.name }} &mdash; {{ item.facilityId }}
                    </template>
                  </v-select>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" type="submit" :loading="loading"
                    >Submit</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-form>

            <v-dialog v-model="listingAccessConfirm" persistent max-width="290">
              <v-card>
                <v-card-title class="headline"> </v-card-title>
                <v-card-text
                  >You've submitted this user without giving them access to any
                  listings. This user will not be able to login to the Partner
                  Platform. Are you sure you want proceed?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="listingAccessConfirm = false"
                  >
                    No, add listings
                  </v-btn>
                  <v-btn color="green darken-1" text @click="createUser">
                    Create user
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </default-layout>
</template>

<script>
import { createUser } from "../../api/user";
import { getCompanyFacilities } from "../../api/company";

export default {
  name: "UserNew",
  title: "New User",
  components: {},

  data: () => ({
    formUser: {
      firstName: "",
      lastName: "",
      email: "",
      companyId: "",
      role: "",
      status: true,
      facilities: [],
      password: "",
      confirmPassword: ""
    },

    roleOptions: [
      {
        id: 1,
        name: "Admin",
        slug: "admin"
      },
      {
        id: 2,
        name: "Admissions",
        slug: "admissions"
      }
    ],
    facilityOptions: [],

    error: null,
    valid: false,
    loading: false,

    listingAccessConfirm: false,

    // VALIDATIONS
    nameRules: [v => !!v || "Name is required"],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    passwordRules: [
      v => !!v || "Password is required",
      v => v.length >= 8 || "Password must be at least 8 characters"
    ]
  }),

  computed: {
    icon() {
      if (this.formUser.facilities.length > 0) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    }
  },

  async mounted() {
    this.getFacilityOptions();
  },

  methods: {
    async getFacilityOptions() {
      this.formUser.companyId = parseInt(this.$route.params.companyId);
      if (this.formUser.companyId) {
        this.loading = true;

        const result = await getCompanyFacilities(this.formUser.companyId);
        this.facilityOptions = result.facilities
          .filter(facility => facility.connectId)
          .map(facility => {
            return {
              id: facility.connectId,
              name: facility.name,
              facilityId: facility.externalId
            };
          });

        this.loading = false;
      }
    },
    async createUser() {
      this.loading = true;
      const valid = this.$refs.userCreateForm.validate();
      if (!valid) {
        this.loading = false;
        return;
      }

      if (
        this.facilityOptions &&
        this.facilityOptions.length &&
        !this.formUser.facilities.length
      ) {
        this.loading = false;
        this.listingAccessConfirm = true;
        return;
      }

      this.listingAccessConfirm = false;
      this.loading = true;

      const result = await createUser(this.formUser);
      this.loading = false;

      this.$router.push({
        name: "UserShow",
        params: { userId: result.userId }
      });
    },
    selectAllToggle() {
      if (this.formUser.facilities.length > 0) {
        return (this.formUser.facilities = []);
      }
      this.formUser.facilities = this.facilityOptions.map(
        facility => facility.id
      );
    }
  }
};
</script>
